import mediasMixin from 'root/mixins/mediasMixin.js'
import utilsMixin from 'root/mixins/utilsMixin.js'
import facetsMixin from 'root/mixins/facetsMixin.js'

export default {
  name: 'pagination',
  mixins: [mediasMixin,utilsMixin,facetsMixin],
  data () {
    return {
      showSort: true
    }
  },

  methods: {
    submitForm (e) {
      // e.target.form.submit()
      e.preventDefault()
      this.$root.$emit('show--spinner--category--page')
      var decodedUrl = e.currentTarget.form.getElementsByTagName('input').namedItem('q').value
      var searchPageDataUrl = decodedUrl.split("?").length > 1 ? (decodedUrl.split("?")[0] + '/getsearchpagedata?' + decodedUrl.split("?")[1]) : decodedUrl + '/getsearchpagedata'
      this.$http.post(searchPageDataUrl, {
        sort: e.currentTarget.value,
        CSRFToken: this.$root.CSRFToken
      },{ emulateJSON: true }).then(response => {
        this.updateFacetData(response)
      }, error => {
        this.isLoading = false
        console.error(error)
      }).finally(() => {
        this.$root.$emit('hide--spinner--category--page')
      })
    }
  },

  computed: {
    sortsComputed() {
      return _.get(this,'searchPageData.sorts')
    },
    
    searchPageData() {
      return this.$root.searchPageData
    }
  },

  created() {
    this.$root.$on("reset-sorting", () => {
      this.showSort = false
      setTimeout(() => {this.showSort = true}, 10)
    })
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/pagination/pagination.js